import { FredhopperSearchProvider } from '../platforms/fredhopper/FredhopperSearchProvider';
/**
 * Birdsnest only ships the Fredhopper provider — the boilerplate's other
 * providers (mock/unbxd/boost/algolia/shopify) are not migrated here. The
 * `providerType` and `mockPlatform` arguments are accepted for signature
 * parity with `useSearchProvider`/`useSuggestionsProvider`/`useRecsProvider`
 * call sites but are ignored.
 */
export function getSearchProvider(providerType, mockPlatform) {
    const provider = providerType;
    switch (provider) {
        case 'fredhopper':
            return new FredhopperSearchProvider();
        default:
            throw new Error(`Unsupported provider: ${provider}`);
    }
}
